import type { CatalogoDoLaboratorio } from "@bookdental/schemas";
import { CapaDoCatalogo } from "./CapaDoCatalogo";
import { ListaDoCatalogo, type AcaoDaLinha } from "./ListaDoCatalogo";
import { RodapeDaFolha, RodapeDoCatalogo } from "./RodapeDoCatalogo";
import { cssDaPagina } from "./pagina-impressa";

const PRETO = "#18181b";

/**
 * O catálogo do laboratório com cara de documento — o mesmo na visualização (que vira PDF pela
 * impressão do navegador) e no link público do QR. Papel branco por padrão; a aparência do
 * laboratório (plano pago) pinta a capa, os títulos e o fundo. `print-color-adjust: exact` faz a
 * impressão levar cor e imagem de fundo, que o navegador descarta por padrão.
 */
export function CatalogoDoLaboratorioDocumento({ catalogo, acaoDaLinha }: { catalogo: CatalogoDoLaboratorio; acaoDaLinha?: AcaoDaLinha }) {
  const { laboratorio: lab, aparencia, capaUrl, comPreco } = catalogo;
  const destaque = aparencia.cor ?? PRETO;
  // Marca d'água sem logo não tem o que mostrar: vira o fundo claro.
  const fundo = aparencia.fundo === "marcaDagua" && !lab.logoUrl ? "claro" : aparencia.fundo;
  const corDoFundo = fundo === "claro" ? (aparencia.cor ? `${aparencia.cor}0f` : "#fafafa") : null;

  return (
    <article
      className={`relative mx-auto w-full max-w-3xl bg-white text-zinc-900 print:max-w-none ${fundo === "branco" ? "" : "overflow-hidden rounded-lg print:rounded-none print:!bg-transparent"}`}
      style={{
        printColorAdjust: "exact",
        WebkitPrintColorAdjust: "exact",
        backgroundColor: corDoFundo ?? undefined,
      }}
    >
      <style>{cssDaPagina(corDoFundo)}</style>
      <RodapeDaFolha nome={lab.nome} aparencia={aparencia} />
      {fundo === "marcaDagua" && (
        // Na impressão, `fixed` repete o logo em toda folha (Chrome); na tela ele fica no topo.
        <img
          src={lab.logoUrl!}
          alt=""
          aria-hidden
          className="pointer-events-none absolute left-1/2 top-40 w-2/3 max-w-md -translate-x-1/2 object-contain opacity-[0.07] print:fixed print:top-1/2 print:-translate-y-1/2"
        />
      )}
      {aparencia.capa.ativa && <CapaDoCatalogo aparencia={aparencia} nome={lab.nome} logoUrl={lab.logoUrl} capaUrl={capaUrl} destaque={destaque} />}
      {/* O respiro fica só na lista (na capa, empurraria a capa pra além da 1ª folha). Na impressão é
          a margem da folha: `clone` repete o recuo de cima e de baixo a cada quebra de página. */}
      <div
        className={`relative print:px-[14mm] print:pb-[20mm] print:pt-[14mm] print:[-webkit-box-decoration-break:clone] print:[box-decoration-break:clone] ${fundo === "branco" ? "" : "p-6"}`}
      >
        <ListaDoCatalogo catalogo={catalogo} destaque={destaque} comCor={!!aparencia.cor} acaoDaLinha={acaoDaLinha} />
        <RodapeDoCatalogo aparencia={aparencia} comPreco={comPreco} />
      </div>
    </article>
  );
}
